
const version = process.env.VERSION;

export default function Version(){
    return <div className="text-font-active font-semibold">
        V{version}
    </div>
}